module.exports = __webpack_public_path__ + "static/media/How can I create an Advance Payment Invoice.fdd77b72.png";